import { legacy_createStore as createStore, applyMiddleware } from 'redux'
import { reducer } from '../services/reducers/index';
import initialState from '../services/initialState';
import {thunk} from 'redux-thunk';

const store = createStore(reducer, initialState, applyMiddleware(thunk));

export default store